import { successCode, pkSignApi, pkValidateApi } from '../api';
import useBiometricManager from './useBiometricManager';
import { getDeviceId } from '../state';
import usePaymentPasswd from './usePaymentPasswd';

export type MFAType = 'biometric' | 'password';

export const useMFAVerify = () => {
  const biometricManager = useBiometricManager();
  const deviceId = getDeviceId();
  const { validatePasswd } = usePaymentPasswd();
  const signMessage = async (
    params: {
      data: any;
      chainid: number;
    },
    device_no: string
  ) => {
    const message = JSON.stringify(params.data);
    const signRes = await pkSignApi({
      message,
      device_no,
    });
    if (!signRes) {
      throw new Error('sign key api failed');
    }
    if (signRes.code != successCode) {
      throw new Error(signRes.message);
    }
    const valRes = await pkValidateApi({
      device_no,
      message,
      sig: signRes.data.signature,
    });
    if (!valRes) {
      throw new Error('validate passkey api failed');
    }
    if (valRes.code != successCode) {
      throw new Error(valRes.message);
    }
    return {
      signature: signRes.data.signature,
      mfa: valRes.data.key,
    };
  };
  const getMFAParams = async (
    params: {
      data: any;
      chainid: number;
    },
    type: MFAType = 'biometric', // 'biometric' or 'password'
    password?: string,
    reason = 'We need your biometric to verify your transaction'
    // callback: (params: { signature: string; mfa: string }) => void
  ): Promise<{
    mfa: any;
    signature: any;
  }> => {
    const res = signMessage(params, deviceId);
    return new Promise((resolve, reject) => {
      if (!deviceId) {
        reject(new Error('Device id not found'));
      }
      // resolve(res);
      // return;
      if (type == 'password') {
        (async () => {
          if (await validatePasswd(password)) {
            const res = await signMessage(params, deviceId);
            resolve(res);
          }
          reject(new Error('Password verify failed'));
        })();
        return;
      }
      //check api verify
      try {
        // resolve(res);
        // return;
        biometricManager.authenticate({
          reason,
          callback: async (success: boolean, token: string) => {
            if (!success) {
              reject(new Error('Biometric verify failed'));
            }
            const res = await signMessage(params, deviceId);
            resolve(res);
          },
          failCallback: (error: Error) => {
            reject(error);
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  return { getMFAParams };
};
